
    var riot = require('riot')
    
riot.tag2('training-search', '<div class="row"> <div class="col-xs-12 col-sm-4"> <h2>Training Quicksearch </h2> <div class="form-horizontal"> <formselect label="Subject" name="techarea" width1="4" width2="8" options="{techareasOptions}" default="All Areas" onupdate="{filter}" value="{selected.techarea}"></formselect> <formselect label="Location" name="country" width1="4" width2="8" options="{countriesOptions}" default="All Locations" onupdate="{filter}" value="{selected.country}"></formselect> <formselect label="Type" name="type" width1="4" width2="8" options="{typesOptions}" default="All Types" onupdate="{filter}" value="{selected.type}"></formselect> <p class="pull-right text-right">{events.length} Results<br> <button onclick="{reset}" class="btn btn-primary btn-sm">Reset Filters</button> </p> </div> </div> <div class="col-xs-12 col-sm-8 outer-results"> <div onmousedown="{scrollLeft}" class="arrow left hidden-xs"><span class="fa fa-caret-left"></span></div> <div onmousedown="{scrollRight}" class="arrow right hidden-xs"><span class="fa fa-caret-right"></span></div> <div name="results" class="row results"> <div riot-style="width:{events.length * 250}px" class="allrow"> <div each="{events}" class="col-xs-12 col-sm-4 result"><a href="{path}"> <div class="title event_block"> <h4>{title}</h4> </div> <div class="rowwrap"> <div class="location event_block">{location}</div> <div class="date event_block">{parent.day(date)}<br>{parent.month(date)}</div> </div></a></div> </div> </div> </div> </div>', '@media (min-width: 768px) { training-search h2, [data-is=training-search] h2, [riot-tag=training-search] h2 { font-size: 24px; padding-right: 20px; } } @media (min-width: 1200px) { training-search h2, [data-is=training-search] h2, [riot-tag=training-search] h2 { font-size: 30px; text-align: right; padding-right: 50px; } } training-search .fa-graduation-cap, [data-is=training-search] .fa-graduation-cap, [riot-tag=training-search] .fa-graduation-cap { padding-right: 5px; font-size: 38px; } training-search .outer-results, [data-is=training-search] .outer-results, [riot-tag=training-search] .outer-results { padding-left: 5px; padding-right: 2px; position: relative; } training-search .arrow, [data-is=training-search] .arrow, [riot-tag=training-search] .arrow { position: absolute; border: 2px solid #2d2e4e; top: 1px; height: 249px; width: 16px; background: rgba(255,255,255,0.1); -webkit-transition: all 0.5s; -moz-transition: all 0.5s; -o-transition: all 0.5s; -ms-transition: all 0.5s; transition: all 0.5s; } training-search .arrow .fa, [data-is=training-search] .arrow .fa, [riot-tag=training-search] .arrow .fa { position: absolute; top: 110px; left: 3px; } training-search .arrow:hover, [data-is=training-search] .arrow:hover, [riot-tag=training-search] .arrow:hover { background: rgba(255,255,255,0.5); } training-search .arrow.right, [data-is=training-search] .arrow.right, [riot-tag=training-search] .arrow.right { right: -9px; } training-search .arrow.left, [data-is=training-search] .arrow.left, [riot-tag=training-search] .arrow.left { left: -15px; } training-search .results, [data-is=training-search] .results, [riot-tag=training-search] .results { height: 261px; overflow-x: auto; overflow-y: hidden; width: 100%; scroll-behavior: smooth; -webkit-overflow-scrolling: touch; } training-search .results::-webkit-scrollbar, [data-is=training-search] .results::-webkit-scrollbar, [riot-tag=training-search] .results::-webkit-scrollbar { height: 10px; } training-search .results::-webkit-scrollbar-track, [data-is=training-search] .results::-webkit-scrollbar-track, [riot-tag=training-search] .results::-webkit-scrollbar-track { background: rgba(255,255,255,0.2); border-radius: 0px; } training-search .results::-webkit-scrollbar-thumb, [data-is=training-search] .results::-webkit-scrollbar-thumb, [riot-tag=training-search] .results::-webkit-scrollbar-thumb { border-radius: 0px; background: #000; width: 5px; } training-search .allrow, [data-is=training-search] .allrow, [riot-tag=training-search] .allrow { white-space: nowrap; } training-search .result, [data-is=training-search] .result, [riot-tag=training-search] .result { display: inline-block; white-space: normal; width: 250px; } training-search a, [data-is=training-search] a, [riot-tag=training-search] a { text-decoration: none; color: #fff; display: block; background: #2d2e4e; -webkit-transition: 0.5s; -moz-transition: 0.5s; -o-transition: 0.5s; -ms-transition: 0.5s; transition: 0.5s; z-index: 1; } training-search a:hover, [data-is=training-search] a:hover, [riot-tag=training-search] a:hover { position: relative; z-index: 10; text-decoration: none; color: #fff; -webkit-transform: scale(1.05); -moz-transform: scale(1.05); -o-transform: scale(1.05); -ms-transform: scale(1.05); transform: scale(1.05); } training-search a:hover .event_block, [data-is=training-search] a:hover .event_block, [riot-tag=training-search] a:hover .event_block { background: rgba(255,255,255,0.1); } training-search .form-horizontal, [data-is=training-search] .form-horizontal, [riot-tag=training-search] .form-horizontal { padding-top: 10px; padding-right: 1px; } @media (min-width: 768px) { training-search .form-horizontal, [data-is=training-search] .form-horizontal, [riot-tag=training-search] .form-horizontal { padding-right: 20px; } } @media (min-width: 1200px) { training-search .form-horizontal, [data-is=training-search] .form-horizontal, [riot-tag=training-search] .form-horizontal { padding-right: 50px; padding-left: 30px; } } training-search .form-group, [data-is=training-search] .form-group, [riot-tag=training-search] .form-group { margin: 0 0 3px 0; } training-search .btn-primary.btn-sm, [data-is=training-search] .btn-primary.btn-sm, [riot-tag=training-search] .btn-primary.btn-sm { font-size: 14px; padding: 5px 10px; margin: 4px 0; } training-search .event_block, [data-is=training-search] .event_block, [riot-tag=training-search] .event_block { background: rgba(255,255,255,0.2); padding: 15px; margin: 1px; overflow: hidden; -webkit-transition: 0.5s; -moz-transition: 0.5s; -o-transition: 0.5s; -ms-transition: 0.5s; transition: 0.5s; } training-search .col-sm-4, [data-is=training-search] .col-sm-4, [riot-tag=training-search] .col-sm-4 { padding: 2px 0; } training-search .title, [data-is=training-search] .title, [riot-tag=training-search] .title { display: -webkit-box; display: -moz-box; display: -webkit-flex; display: -ms-flexbox; display: box; display: flex; -webkit-box-align: center; -moz-box-align: center; -o-box-align: center; -ms-flex-align: center; -webkit-align-items: center; align-items: center; -webkit-box-pack: center; -moz-box-pack: center; -o-box-pack: center; -ms-flex-pack: center; -webkit-justify-content: center; justify-content: center; height: 173px; } training-search .title h4, [data-is=training-search] .title h4, [riot-tag=training-search] .title h4 { font-size: 21px; white-space: wrap; -o-text-overflow: ellipsis; text-overflow: ellipsis; overflow: hidden; word-break: break-all; word-break: break-word; } training-search .rowwrap, [data-is=training-search] .rowwrap, [riot-tag=training-search] .rowwrap { display: -webkit-box; display: -moz-box; display: -webkit-flex; display: -ms-flexbox; display: box; display: flex; } training-search .location, [data-is=training-search] .location, [riot-tag=training-search] .location { display: -webkit-box; display: -moz-box; display: -webkit-flex; display: -ms-flexbox; display: box; display: flex; -webkit-box-align: center; -moz-box-align: center; -o-box-align: center; -ms-flex-align: center; -webkit-align-items: center; align-items: center; height: 70px; overflow: hidden; -o-text-overflow: ellipsis; text-overflow: ellipsis; white-space: wrap; -webkit-box-flex: 1; -moz-box-flex: 1; -o-box-flex: 1; -ms-box-flex: 1; box-flex: 1; -webkit-flex-grow: 1; flex-grow: 1; } training-search .date, [data-is=training-search] .date, [riot-tag=training-search] .date { text-align: center; font-size: 20px; line-height: 20px; display: inline-block; width: 80px; }', '', function(opts) {
var xhr;

xhr = require("../libs/xhr.coffee");

this.events = [];

this.allevents = [];

this.months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

this.day = (function(_this) {
  return function(dt) {
    return dt.getDate();
  };
})(this);

this.month = (function(_this) {
  return function(dt) {
    return _this.months[dt.getMonth()];
  };
})(this);

this.techareas = [];

this.countries = [];

this.types = [];

this.techareasOptions = [];

this.countriesOptions = [];

this.typesOptions = [];

this.selected = {};

this.on("mount", function() {
  return xhr("get", "/duocms/api/training", null, (function(_this) {
    return function(res) {
      return _this.process(res.body.data);
    };
  })(this));
});

this.on("unmount", function() {
  return this.stopRepeater();
});

this.reset = (function(_this) {
  return function() {
    _this.selected.techarea = "";
    _this.selected.country = "";
    _this.selected.type = "";
    _this.update();
    return _this.filter();
  };
})(this);

this.repeater = (function(_this) {
  return function(cback) {
    _this.mousedown = true;
    document.addEventListener("mouseup", _this.stopRepeater);
    return _this.repeaterTimeOut = setInterval(function() {
      if (_this.mousedown === true) {
        return cback();
      } else {
        return _this.stopRepeater();
      }
    }, 300);
  };
})(this);

this.stopRepeater = (function(_this) {
  return function() {
    _this.mousedown = false;
    document.removeEventListener("mouseup", _this.stopRepeater);
    if (_this.repeaterTimeOut) {
      return clearTimeout(_this.repeaterTimeOut);
    }
  };
})(this);

this.scrollLeft = (function(_this) {
  return function() {
    var x;
    x = _this.results.scrollLeft;
    _this.results.scrollTo(x - 250, 0);
    if (!_this.mousedown) {
      return _this.repeater(_this.scrollLeft);
    }
  };
})(this);

this.scrollRight = (function(_this) {
  return function() {
    var x;
    x = _this.results.scrollLeft;
    _this.results.scrollTo(x + 250, 0);
    if (!_this.mousedown) {
      return _this.repeater(_this.scrollRight);
    }
  };
})(this);

this.process = (function(_this) {
  return function(data) {
    if (!data || !Array.isArray(data)) {
      return;
    }
    data.forEach(function(row) {
      var ref;
      if ((ref = row.techarea) != null) {
        ref.split(",").map(function(a) {
          var techarea;
          techarea = a.trim();
          if (techarea && _this.techareas.indexOf(techarea) === -1) {
            return _this.techareas.push(techarea);
          }
        });
      }
      if (row.country && _this.countries.indexOf(row.country) === -1) {
        _this.countries.push(row.country);
      }
      if (row.type && _this.types.indexOf(row.type) === -1) {
        return _this.types.push(row.type);
      }
    });
    _this.techareasOptions = _this.techareas.sort().map(function(a) {
      return {
        label: a,
        value: a
      };
    });
    _this.countriesOptions = _this.countries.sort().map(function(a) {
      return {
        label: a,
        value: a
      };
    });
    _this.typesOptions = _this.types.sort().map(function(a) {
      return {
        label: a,
        value: a
      };
    });
    _this.events = data.map(function(row) {
      return {
        title: row.title,
        location: row.location + ", " + row.country,
        date: new Date(row.start),
        path: row.path,
        country: row.country,
        techarea: row.techarea,
        type: row.type
      };
    });
    _this.allevents = _this.events.slice();
    return _this.update();
  };
})(this);

this.filter = (function(_this) {
  return function(e) {
    if (e) {
      _this.selected[e.name] = e.value;
    }
    _this.events = _this.allevents.filter(function(ev) {
      var ref;
      return (!_this.selected.techarea || ((ref = ev.techarea) != null ? ref.match(_this.selected.techarea) : void 0)) && (!_this.selected.country || ev.country === _this.selected.country) && (!_this.selected.type || ev.type === _this.selected.type);
    });
    return _this.update();
  };
})(this);
});
    
  